<div class="grid ">
	<div class="col-12">
		<div class="card">
			<h4>Detalhar Usuário</h4>			
			<form *ngIf="usuario">
				<div class="p-fluid p-formgrid grid" *ngIf="loadingUsuario">
                    <div class="field col-12 md:col-12">
                        <p-divider></p-divider>
                    </div>
                </div>
                <div class="flex justify-content-center" *ngIf="loadingUsuario">
                    <p-progressSpinner></p-progressSpinner>
                </div>
				<div class="formgroup" *ngIf="usuario">
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-12">
							<p-divider></p-divider>
						</div>
				
						<div class="form-group field col-12 md:col-4">
							<label>Nome</label>
							<label class="form-control" >{{ usuario.nome }}</label>
						</div>

                        <div class="form-group field col-12 md:col-2">
							<label>Nome</label>
							<label class="form-control" >{{ usuario.apelido }}</label>
						</div>

                        <div class="form-group field col-12 md:col-3">
							<label>WhatsApp</label>
							<label class="form-control" >{{ usuario.whatsapp }}</label>
						</div>

                        <div class="form-group field col-12 md:col-3">
							<label>CPF</label>
							<label class="form-control" >{{ usuario.cpf | cnpjFormat }}</label>
						</div>

                        <div class="form-group field col-12 md:col-3">
							<label>E-mail</label>
							<label class="form-control" >{{ usuario.email }}</label>
						</div>

                        <div class="form-group field col-12 md:col-3">
							<label>Tipo</label>
							<label class="form-control" >{{ usuario.tipo }}</label>
						</div>

						<div class="form-group field col-12 md:col-3">
							<label>Dt. Cadastro</label>
							<label class="form-control" >{{ usuario.dataCriacao | date :'dd-MM-yyyy HH:mm:ss' }}</label>
						</div>

						<div class="form-group field col-12 md:col-3">
							<label>Dt. Atualização</label>
							<label class="form-control" >{{ usuario.dataAtualizacao | date :'dd-MM-yyyy HH:mm:ss' }}</label>
						</div>


					

					</div>
					<div class="col-12 md:col-12" *ngIf="administradoras.length > 0">
						<h5>Franquias Vinculadas</h5>
					</div>
					<p-table #dt1 [value]="administradoras" dataKey="id" [rowHover]="true" *ngIf="administradoras.length > 0"
						styleClass="p-datatable-gridlines" responsiveLayout="scroll" styleClass=" p-datatable-sm">
						<ng-template pTemplate="header">
							<tr>
								<th pSortableColumn="nomeFantasia" >
									Nome
									<p-sortIcon field="nomeFantasia">
									</p-sortIcon>
								</th>
								<th pSortableColumn="cnpj" >
									CNPJ
									<p-sortIcon field="cnpj">
									</p-sortIcon>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-item>
							<tr>
								<td>
									{{item.nomeFantasia}}
								</td>
								<td>
									{{item.cnpj}}
								</td>
							</tr>
						</ng-template>
					</p-table>
					<div class="col-12 md:col-12" *ngIf="empresas.length > 0">
						<h5>Empresas Vinculadas</h5>
					</div>
					<p-table #dt1 [value]="empresas" dataKey="id" [rowHover]="true" *ngIf="empresas.length > 0"
						styleClass="p-datatable-gridlines" responsiveLayout="scroll" styleClass=" p-datatable-sm">
						<ng-template pTemplate="header">
							<tr>
								<th pSortableColumn="nomeFantasia" >
									Nome
									<p-sortIcon field="nomeFantasia">
									</p-sortIcon>
								</th>
								<th pSortableColumn="cnpj" >
									CNPJ
									<p-sortIcon field="cnpj">
									</p-sortIcon>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-item>
							<tr>
								<td>
									{{item.nomeFantasia}}
								</td>
								<td>
									{{item.cnpjCpf}}
								</td>
							</tr>
						</ng-template>
						
					</p-table>

					<div class="p-fluid p-formgrid grid justify-content-end">
						<div class="field col-12 md:col-2">
							<button type="button"  pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-primary mt-5" routerLink="/rfarias/usuario"></button>
						</div>
					</div>
			
				</div>
			</form>
			
		</div>
	</div>
</div>